/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
// import config from '../../config/getFee.config.json';
import axios from 'axios';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { Graphql } from '@common/graphql';
import { GET_FEE, GET_STATUS } from '../../api/graphql';
import { StorageModule } from '@vlinder-web/storage-module-react';

export interface IGetFeeMethods extends IPluginMethodMap {
  getFee(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class GetFeeService implements IAgentPlugin {
  readonly methods: IGetFeeMethods;

  constructor() {
    this.methods = {
      getFee: this.getFee.bind(this),
    };
  }

  async getFee(args: any) {
    console.log(`getFee service:`, args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const storageService = StorageModule.getInstance();
    const payableApplications = storageService.get(
      'payableApplications',
      'session'
    );
    const applications = payableApplications?.map((item: any) => item?.id);

    console.log('payableApplications', payableApplications);

    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        console.log(client);
        const res = await client
          .query(GET_FEE, {
            applicationNo: payableApplications[0]?.id,
          })
          .toPromise();
        if (res?.data?.calculateFee) {
          // const formatData=this.formatFees(res?.data?.getFeeConfiguration,applications)
          console.log('li->prices', res?.data?.calculateFee);
          // return { data: formatData };
          return {
            data: {
              price: res?.data?.calculateFee?.amount,
              currency: res?.data?.calculateFee?.currency,
              formattedAmount: res?.data?.calculateFee?.formattedAmount,
              type: this.getFormattedType(
                res?.data?.calculateFee?.applicationType
              ),
              paymentFor:this.getFormattedPaymentFor(res?.data?.calculateFee?.feeType)
            },
          };
          // return  {status: "SUCCESS"}
        }
      }
    } catch (err: any) {
      console.log(`Payment user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }

  private getFormattedPaymentFor(type: string) {
    if (type) {
      switch (type) {
        case 'APP_PROCESSING_FEE':
          return 'Processing Fee';
        case 'WORK_PERMIT_FEE':
          return 'Work Permit Fee';
        default:
          return 'Fee';
      }
    }
  }

  private getFormattedType(type: string) {
    if (type) {
      switch (type) {
        case 'NEW_CSME_CERTIFICATE':
          return 'CSME New';
        case 'MARRIAGE_EXEMPTION':
          return 'Marriage Exemption';
        case 'NEW_WORK_PERMIT':
          return 'New Work Permit';
        case 'RENEW_WORK_PERMIT':
          return 'Renew Work Permit';
          case 'RENEW_MARRIAGE_EXEMPTION':
            return 'Renew Marriage Exemption'
        default:
          return 'Amount';
      }
    }
  }

  // private formatFees(data: any, applications: any[]) {
  //   console.log('li->', applications);
  //   let prices = applications?.map((item: string) => {
  //     if (item?.startsWith('RWP')) {
  //       return {
  //         label: 'Renew Work Permit',
  //         price: data?.renewWorkPermit,
  //       };
  //     }
  //     if (item?.startsWith('NWP')) {
  //       return {
  //         label: 'New Work Permit',
  //         price: data?.newWorkPermit,
  //       };
  //     }
  //   });
  //   return prices;
  // }
}
